import { render, staticRenderFns } from "./StepPreview.vue?vue&type=template&id=4529a532&scoped=true"
import script from "./StepPreview.vue?vue&type=script&lang=js"
export * from "./StepPreview.vue?vue&type=script&lang=js"
import style0 from "./StepPreview.vue?vue&type=style&index=0&id=4529a532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529a532",
  null
  
)

export default component.exports